import dayjs from "dayjs"
import { store } from "../store"
import { setErrorMessage, setSuccessMessage } from "../store/messageSlice"

export const DATE_PATTERN_DD_MMMM_YYYY_HH_mm = "DD MMMM YYYY HH:mm"
export const DATE_PATTERN_DD_MMM_YYYY_DASH = "DD-MMM-YYYY"

export function toIndoFormat(value: number, maxDigit: number = 0): string {
    return Intl.NumberFormat('id-ID', {
        minimumFractionDigits: 0,
        maximumFractionDigits: maxDigit
    }).format(value)
}

// DATE utc() is used to take the date as raw, need to send a Z date though
export function convertDateToUTC(day: string, pattern: string = DATE_PATTERN_DD_MMMM_YYYY_HH_mm) {
    return dayjs(day).utc().format(pattern)
}

export function lastItemOfArray(value: any[] | undefined) {
    if (isArrayNullOrEmpty(value)) return undefined
    return value![value!.length - 1]
}

export function isArrayNullOrEmpty(value: any[] | undefined) {
    return value === null || value === undefined || value.length === 0
}

export function isNullOrEmpty(value?: string | null) {
    return value === null || value === undefined || value.length === 0
}

export function isNullOrUndefined(value?: any): boolean {
    return value === null || value === undefined
}

export const showErrorMessage = (message: string) => {
    store.dispatch(setErrorMessage(message))
}

export const showSuccessMessage = (message: string) => {
    store.dispatch(setSuccessMessage(message))
}

export function getErrorMessage(error: any) {
    var maybeError = error
    var e = error?.graphQLErrors?.at(0)?.extensions?.errors
    e = (e as any)?.at(0)?.message
    if (!e) {
        e = error?.message
    }
    maybeError = e ?? error
    console.log('show err', maybeError)
    return JSON.stringify(maybeError)
}

export const copyToClipboard = (vaNumber: string) => {
    navigator.clipboard.writeText(vaNumber);
    console.log(`Copied VA number: ${vaNumber}`);
};

export function extractStoragePath(url: string): string {
    const baseUrl = 'https://storage.googleapis.com/';
    
    if (!url || !url.startsWith(baseUrl)) {
        return url; // Return original if not a GCS URL
    }
    
    // Remove base URL
    const afterBase = url.substring(baseUrl.length);
    
    // Find the query string start
    const queryIndex = afterBase.indexOf('?');
    
    // Return everything before the query string, or the whole thing if no query
    return queryIndex === -1 ? afterBase : afterBase.substring(0, queryIndex);
}
